import "core-js/modules/es7.array.includes";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";
import Vue from "vue";
import VueI18n from "vue-i18n"; // import messages from '@/lang/en'

Vue.use(VueI18n);
export var i18n = new VueI18n({
  locale: "en",
  fallbackLocale: "en",
  messages: {
    en: require("@/lang/en") //默认en

  }
});
var loadedLanguages = ["en"]; // 我们的预装默认语言

var setI18nLanguage = function setI18nLanguage(lang) {
  i18n.locale = lang;
  return lang;
};

export function loadLanguageAsync(lang) {
  console.log("loadLanguageAsync lang:", lang);
  return new _Promise(
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(resolve, reject) {
      var result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              if (!(i18n.locale !== lang)) {
                _context.next = 11;
                break;
              }

              if (loadedLanguages.includes(lang)) {
                _context.next = 8;
                break;
              }

              _context.next = 5;
              return import(
              /* webpackChunkName: "lang-[request]" */
              "@/lang/".concat(lang));

            case 5:
              result = _context.sent;
              // console.log("loadLanguageAsync result:", result);
              i18n.setLocaleMessage(lang, result.default);
              loadedLanguages.push(lang);

            case 8:
              resolve(setI18nLanguage(lang));
              _context.next = 12;
              break;

            case 11:
              resolve(lang);

            case 12:
              _context.next = 18;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](0);
              console.log("loadLanguageAsync error:", _context.t0);
              reject(_context.t0);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 14]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
}